﻿import type { EventTypeDto } from '@/types'
import axios from '@/api/axios'

const path = `event-types`

export async function getEventTypeById(id: number, partitionKey: string) {
    const { data } = await axios.get<EventTypeDto>(`${path}/${partitionKey}/${id}`)
    return data
}

export async function getAllEventTypes() {
    const { data } = await axios.get<EventTypeDto[]>(`${path}`)
    return data
}

export async function createEventType(event: EventTypeDto) {
    const { data } = await axios.post<EventTypeDto[]>(`${path}`, event)
    return data
}

export async function updateEventType(event: EventTypeDto) {
    const { data } = await axios.put<EventTypeDto[]>(`${path}`, event)
    return data
}

export async function deleteEventTypeById(id: number, partitionKey: string) {
    const { data } = await axios.delete<EventTypeDto[]>(`${path}/${partitionKey}/${id}`)
    return data
}
